Date.today = function() {
    var now = new Date();
    return new Date(now.getFullYear(), now.getMonth(), now.getDate());
};

Date.prototype.addDays = function(numDays) {
    var time = this.getTime();
    var offset = numDays * 24 * 60 * 60 * 1000; // milliseconds
    return new Date(time + offset);
};

// This is the format we use for serializing dates.
Date.prototype.yyyymmdd = function() {
    var yyyy = this.getFullYear(),
        mm = this.getMonth() + 1,
        dd = this.getDate();

    return yyyy + '-' + (mm < 10 ? '0' + mm : mm) + '-' + (dd < 10 ? '0' + dd : dd);
};


Date.prototype.mmddyyyy = function() {
    var yyyy = this.getFullYear(),
        mm = this.getMonth() + 1,
        dd = this.getDate();

    return (mm < 10 ? '0' + mm : mm) + '-' + (dd < 10 ? '0' + dd : dd) + '-' + yyyy;
};